/* @flow */

import React, { Component } from 'react';
import glamorous from 'glamorous';

type Props = {
  height: number,
  id: string,
  width: number,
};

const Slot = glamorous.div(props => ({
  // height: props.height,
  margin: '0 auto',
  width: props.width,
}));

class AdvertSlot extends Component<Props> {
  props: Props;

  componentDidMount() {
    const { id } = this.props;

    window.googletag.cmd.push(() => {
      window.googletag.display(id);
    });
  }

  render() {
    const { height, id, width } = this.props;

    return (
      <Slot
        id={id}
        height={height}
        width={width}
      />
    );
  }
}

export default AdvertSlot;
